import React from 'react';
import { CodeIcon, LayoutTemplateIcon, ShoppingBagIcon, WorkflowIcon, MegaphoneIcon, CompassIcon, ArrowUpRightIcon } from 'lucide-react';
import { services } from '../data/content';
import { Reveal } from './Reveal';
const icons = [CodeIcon, LayoutTemplateIcon, ShoppingBagIcon, WorkflowIcon, MegaphoneIcon, CompassIcon];
export function Services() {
  return <section id="servicios" className="scroll-mt-24 border-y border-slate-200/80 bg-white py-24 lg:py-32" data-id="element-129" data-mp="13weg1hrg1ul7">
      <div className="mx-auto max-w-7xl px-6 lg:px-10" data-id="element-130" data-mp="z4mqnak0xuwn">
        <Reveal className="max-w-2xl" data-id="element-131" data-mp="z31tdd6brxv3">
          <p className="text-[13px] font-medium uppercase tracking-[0.16em] text-accent" data-id="element-132" data-mp="u5jpw2b2uauh">
            Servicios
          </p>
          <h2 className="mt-4 text-4xl font-semibold leading-[1.1] tracking-[-0.03em] text-ink lg:text-5xl" data-id="element-133" data-mp="q5reziy7nsly">
            Nuestros servicios
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-ink-soft" data-id="element-134" data-mp="g6k3z2ey8a20">
            Desde la primera versión de tu producto hasta la optimización continua, cubrimos todo el
            ciclo de vida digital.
          </p>
        </Reveal>

        <ul className="mt-14 grid gap-6 md:grid-cols-2 lg:grid-cols-3" data-id="element-135" data-mp="3b47vcgr5wbs5">
          {services.map((service, i) => {
          const Icon = icons[i];
          return <li key={service.title} data-id="element-136" data-mp="32acqzaxv6pdk" data-mpi={i}>
                <Reveal delay={i % 3 * 0.08} data-id="element-137" data-mp="32be2fgisldvt">
                  <article className="group relative h-full overflow-hidden rounded-3xl border border-slate-200/80 bg-canvas p-7 transition-all duration-300 hover:-translate-y-1.5 hover:border-accent/30 hover:bg-white hover:shadow-lift" data-id="element-138" data-mp="3q0qc0hi17nyn">
                    <div className="flex items-start justify-between" data-id="element-139" data-mp="3g1hljymdkrh1">
                      <span className="inline-flex h-11 w-11 items-center justify-center rounded-2xl border border-slate-200 bg-white text-ink transition-colors duration-300 group-hover:border-accent group-hover:bg-accent group-hover:text-white" data-id="element-140" data-mp="3l0uff3bnyyt4">
                        <Icon className="h-5 w-5" strokeWidth={1.6} aria-hidden="true" data-id="element-141" data-mp="29niasq82yc5w" />
                      </span>
                      <ArrowUpRightIcon className="h-5 w-5 text-slate-300 transition-all duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-accent" aria-hidden="true" data-id="element-142" data-mp="1plx4vlxmwfg0" />
                    </div>
                    <h3 className="mt-6 text-lg font-semibold tracking-[-0.01em] text-ink" data-id="element-143" data-mp="1bqv2h8rzx87y">
                      {service.title}
                    </h3>
                    <p className="mt-2 text-[15px] leading-relaxed text-ink-soft" data-id="element-144" data-mp="11tqf55mez6pk">
                      {service.description}
                    </p>
                  </article>
                </Reveal>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}